var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQmeeLeagues = function SvgQmeeLeagues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M2.031 11.79h4.142c.155 0 .282.126.282.282v6.963a.28.28 0 0 1-.282.28H2.03a.28.28 0 0 1-.281-.28v-6.963c0-.155.126-.281.281-.281ZM18.492 7.842h3.933c.28 0 .383.191.384.282v10.912c0 .09-.104.28-.384.28h-3.933c-.28 0-.384-.19-.384-.28V8.124c0-.09.104-.282.384-.282ZM10.241 2.686h3.933c.28 0 .383.19.384.28v16.07c0 .09-.104.281-.384.281H10.24c-.28 0-.384-.192-.384-.282V2.967c0-.09.104-.281.384-.281Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4A5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33 9.333V17.5M37 15l-4 4-4-4"
  })));
};
export default SvgQmeeLeagues;